'use strict';

function createEvents(eventDefinitions, prevState, action) {
  var asArray = function asArray(value) {
    return Array.isArray(value) ? value : [value];
  };

  return asArray(eventDefinitions).map(function (_ref) {
    var eventName = _ref.eventName,
        eventFields = _ref.eventFields,
        eventSchema = _ref.eventSchema;

    var name = { event: eventName || action.type };
    var fields = typeof eventFields === 'function' ? eventFields(prevState, action) : {};

    var event = Object.assign(name, fields);

    if (eventSchema !== undefined) {
      var eventPropIsValid = function eventPropIsValid(prop) {
        return eventSchema[prop](event[prop]);
      };
      var isValid = Object.keys(eventSchema).every(eventPropIsValid);
      if (isValid) {
        return event;
      }
      return 'Schema validation failure for ' + event.event;
    }

    return event;
  }).filter(function (event) {
    return typeof event !== 'string';
  });
}

module.exports = createEvents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/create-events.js
// module id = 172
// module chunks = 0